<template>
  <b-card v-if="showCommissionCard" :title="$t('commission')" class="mb-4 commission-card">
    <b-card-text>
      <div v-if="isLoading" class="text-center">
        <Spinner :size="25" />
      </div>
      <div v-else-if="commissionData" class="commission-info">
        <div class="commission-grid">
          <div class="label">{{ $t('name') }}:</div>
          <div class="value">
            {{ currentUserSalesMember.user.firstname }}
            {{ currentUserSalesMember.user.lastname }}
          </div>
          <div class="label">{{ $t('team') }}:</div>
          <div class="value">
            {{ commissionData.teamName }}
          </div>
          <div class="label">{{ $t('commission') }}:</div>
          <div class="value commission-rate">
            <b-badge variant="success" class="commission-badge">
              {{ formattedCommissionRate }}%
            </b-badge>
          </div>
        </div>
      </div>
      <div v-else class="text-muted">
        {{ $t('noCommissionData') }}
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Spinner from '@/components/Spinner.vue';

export default {
  name: 'SalesMemberCard',
  components: {
    Spinner,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['getCurrentUser']),
    ...mapGetters(['getCurrentUserCommissionData', 'getCurrentUserSalesMember']),
    showCommissionCard() {
      // Show if current user is in charge of the project
      if (!this.project || !this.project.sales || !this.project.sales.inCharge) {
        return false;
      }
      return this.project.sales.inCharge.id === this.getCurrentUser.id;
    },
    commissionData() {
      return this.getCurrentUserCommissionData;
    },
    currentUserSalesMember() {
      return this.getCurrentUserSalesMember;
    },

    formattedCommissionRate() {
      if (!this.commissionData || this.commissionData.commissionRate === undefined) {
        return '0.00';
      }
      // Convert from decimal to percentage (0.05 -> 5.00)
      return (this.commissionData.commissionRate * 100).toFixed(2);
    },
  },
  methods: {
    ...mapActions(['fetchSalesMemberByUser']),
    async loadCommissionData() {
      if (!this.showCommissionCard) {
        return;
      }

      this.isLoading = true;
      try {
        await this.fetchSalesMemberByUser(this.getCurrentUser.id);
      } catch (error) {
        console.error('Error loading commission data:', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  watch: {
    showCommissionCard: {
      handler(newVal) {
        if (newVal) {
          this.loadCommissionData();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.commission-info {
  .commission-grid {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0.75rem;
    align-items: center;

    .label {
      font-weight: 500;
      color: #6c757d;
    }

    .value {
      font-size: 1rem;
    }

    .commission-rate {
      .commission-badge {
        font-size: 1rem;
        padding: 0.4rem 0.8rem;
      }
    }
  }
}
</style>
